import React from 'react';
import {Table} from "semantic-ui-react";
import NumberFormat from "react-number-format";


const ItemsDetailsTable = ({ title, items }) => {
    const safeItems = Array.isArray(items) ? items : [];
    return (
        <Table className={'itemsDetailsTable'}>
            <Table.Header>
                <Table.Row style={{padding: 0}}>
                    <Table.Cell className={'neutral600Text'}>
                        { title }
                    </Table.Cell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    safeItems.map((item, index) => {
                        if (item?.value == null) {
                            return null;
                        }

                        const name = item?.name || 'Item';

                        const keyName = String(name || index).toLowerCase();

                        return (
                            <Table.Row key={`item-${keyName}-${index}`} className={'neutral900Text'}>
                                <Table.Cell><b>{ name }</b></Table.Cell>
                                <Table.Cell>
                                    <NumberFormat
                                        value={item.value}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        );
                    })
                }
            </Table.Body>
        </Table>
    );
};

export default ItemsDetailsTable;
